module.exports = __webpack_public_path__ + "img/centralizedfeaturesacrossdepartments.b20b262d.png";